import axios from 'axios'
import store from "@/store";

export default {
    state: {
        userUpcomingSessions: [],
        userTrendingSessions: [],
        userRecommendedSessions: [],
        userRecommendedCourses: [],
        loadingStatus: false,
        userTrendingCourses: [],
        userLiveSession: [],
        trainerStripeUrl: [],
        trainerStripeConnect: [],
        userBannerUpcomingClass: [],
        userRecentClasses: []
    },

    getters: {
        userRecentClasses(state) {
            return state.userRecentClasses
        },
        landingBannerData(state) {
            return state.userBannerUpcomingClass
        },
        trainerStripeConnect(state) {
            return state.trainerStripeConnect
        },
        trainerStripeUrl(state) {
            return state.trainerStripeUrl
        },
        loadingStatus(state) {
            return state.loadingStatus
        },
        userUpcomingSessions(state) {
            return state.userUpcomingSessions
        },
        userTrendingSessions(state) {
            return state.userTrendingSessions
        },
        userRecommendedSessions(state) {
            return state.userRecommendedSessions
        },
        userRecommendedCourses(state) {
            return state.userRecommendedCourses
        },
        userTrendingCourses(state) {
            return state.userTrendingCourses
        },
        userLiveSession(state) {
            return state.userLiveSession
        }
    },

    actions: {
        async getUserUpcomingSessions({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/upcoming/sessions', { params: query || {} })
                .then(res => {

                    commit('setUserUpcomingSessions', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {

                    commit('setUserUpcomingSessions', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },

        async getUserTrendingSessions({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/trending/sessions', { params: query || {} })
                .then(res => {

                    commit('setUserTrendingSessions', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {
                    commit('setUserTrendingSessions', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },

        async getUserTrendingCourses({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/trending/courses', { params: query || {} })
                .then(res => {

                    commit('setUserTrendingCourses', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {
                    commit('setUserTrendingCourses', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },

        async getUserRecommendedSessions({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/recommended/sessions', { params: query || {} })
                .then(res => {
                    commit('setUserRecommendedSessions', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {
                    commit('setUserRecommendedSessions', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },

        async getUserRecommendedCourses({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/recommended/courses', { params: query || {} })
                .then(res => {
                    commit('setUserRecommendedCourses', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {
                    commit('setUserRecommendedCourses', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },

        async getUserLiveSession({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/live-session', { params: query || {} })
                .then(res => {
                    commit('setUserLiveSession', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {
                    commit('setUserLiveSession', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },

        async getTrainerStripeUrl({ commit }) {
            const res = await axios.get('trainer/stripe-url')

            const data = res.data;
            commit("setTrainerStripeUrl", data);
        },

        async postTrainerStripeConnect({ commit }, code) {
            try {
                const res = await axios.post(`trainer/stripe-connect/${code}`);
                store.commit('setIsLoading', false)
                store.commit("setIsSuccess", "Successfully connected to your stripe account");
                const data = res.data;
                commit("setTrainerStripeConnect", data);
            } catch(err) {
                store.commit('setIsLoading', false)
                store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
            }
        },

        async getLandingBannerData({ commit }, payload) {
            try {
              const res = await axios.get('user/get-landing-banner/' + payload)
              const data = res.data && res.data.data;
              commit("setUserBannerUpcomingClass", data);
            } catch(err) {
                console.log(err)
            }
        },

        async getUserRecentClasses({ commit }, { query }) {
            commit('loadingStatus', true)

            await axios.get('user/recent-classes', { params: query || {} })
                .then(res => {

                    commit('setUserRecentClasses', (res && res.data) || {})
                    commit('loadingStatus', false)
                })
                .catch((e) => {

                    commit('setUserRecentClasses', (e.response && e.response.data) || {})
                    commit('loadingStatus', false)
                })
        },
    },

    mutations: {
        setUserRecentClasses(state, data) {
            state.userRecentClasses = data
        },

        setUserBannerUpcomingClass(state, data) {
            state.userBannerUpcomingClass = data
        },

        setTrainerStripeConnect(state, data) {
            state.trainerStripeConnect = data
        },

        setTrainerStripeUrl(state, data) {
            state.trainerStripeUrl = data
        },

        loadingStatus(state, newLoadingStatus) {
            state.loadingStatus = newLoadingStatus
        },

        setUserUpcomingSessions(state, data) {
            state.userUpcomingSessions = data
        },

        setUserTrendingSessions(state, data) {
            state.userTrendingSessions = data
        },

        setUserTrendingCourses(state, data) {
            state.userTrendingCourses = data
        },

        setUserRecommendedSessions(state, data) {
            state.userRecommendedSessions = data
        },
        setUserRecommendedCourses(state, data) {
            state.userRecommendedCourses = data
        },
        setUserLiveSession(state, data) {
            state.userLiveSession = data
        }
    }
}